<template>
  <dialogPanel
      ref="refDialog"
      :dialogState="fdialogState"
      @event-dialog-close="eventDialogClose"
      title="信息发布"
      wth="600"
      hth="454">
    <markdownEditor
        ref="refMarkdown"
        mavon-class="mavon-360"></markdownEditor>
    <div class="topic-footer">
      <span @click="releaseClick">发布</span>
    </div>
  </dialogPanel>
</template>

<script>
import dialogPanel from "@/components/panel/dialogPanel";
import markdownEditor from "@/components/common/markdownEditor";
import utils from "@/utils/utils";
import serviceApi from "@/utils/serviceApi";
export default {
  name: "topicDialog",
  data(){
    return{
      summaryInfo: ''
    }
  },
  props:{
    dialogState:{
      type: Boolean,
      default: false
    }
  },
  computed:{
    fdialogState:function (){
      return this.dialogState
    }
  },
  methods:{
    eventDialogClose:function (){
      this.$emit("event-dialog-close")
    },
    setContext(value){
      this.$refs.refMarkdown.setContext(value)
    },
    releaseClick: function (){
      let htmlStr = this.$refs.refMarkdown.getContent();
      if (htmlStr == 'undefined' || htmlStr == undefined || htmlStr == ''){
        return
      }
      let topicInfo = {
        topicId: utils.guid(),
        answerContext: encodeURI(htmlStr),
        summaryInfo: this.summaryInfo
      }
      serviceApi.updateTopics(topicInfo,()=>{
        this.$refs.refDialog.dialogClose();
        location.reload()
      })
    }
  },
  components:{
    dialogPanel,
    markdownEditor
  }
}
</script>

<style scoped>
.topic-footer{
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #eee;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.topic-footer span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: right;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #2e7eee;
}
.topic-footer span:hover{
  background-color: #2e7eee;
  color: #fff;
}
</style>
